export default __webpack_public_path__ + "static/media/base.sprite.823eba67bfb2bba7011a8d0769e04643.svg";